import {defaultDeleteMutationOptions, defaultResponseHandler, useQueryWrapper} from "./api-hooks-common";
import {FilesApi, FileUploadDTO} from "../FilesApi";
import {useMutation, useQueryClient} from "@tanstack/react-query";

export enum FileQueryKey {
    PUBLIC_FILES = 'public-files',
    COMPANY_FILES = 'company-files'
}

export const useGetPublicFiles = () => useQueryWrapper([FileQueryKey.PUBLIC_FILES], () => FilesApi.getPublicFiles(), null, {
    refetchInterval: 5000
});

export const useGetCompanyFiles = (enabled: boolean) => useQueryWrapper([FileQueryKey.COMPANY_FILES], () => FilesApi.getCompanyFiles(), null, {
    refetchInterval: 5000,
    enabled: enabled
});

export const useDeletePublicFile = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: string) => FilesApi.deletePublicFile(data).then(defaultResponseHandler),
        onSuccess: (data, variables) => {
            defaultDeleteMutationOptions.onSuccess!!();
            queryClient.setQueryData([FileQueryKey.PUBLIC_FILES], (e: FileUploadDTO[]) => {
                return e.filter((o: FileUploadDTO) => o.downloadUrlPart !== variables);
            });
        },
        onError: error => {
            defaultDeleteMutationOptions.onFailure!!(error);
        },
        onMutate: variables => {
            defaultDeleteMutationOptions.onMutate!!(variables);
        }
    });
};

export const useDeleteCompanyFile = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: string) => FilesApi.deleteCompanyFile(data).then(defaultResponseHandler),
        onSuccess: (data, variables) => {
            defaultDeleteMutationOptions.onSuccess!!();
            queryClient.setQueryData([FileQueryKey.COMPANY_FILES], (e: FileUploadDTO[]) => {
                return e.filter((o: FileUploadDTO) => o.downloadUrlPart !== variables);
            });
        },
        onError: error => {
            defaultDeleteMutationOptions.onFailure!!(error);
        },
        onMutate: variables => {
            defaultDeleteMutationOptions.onMutate!!(variables);
        }
    });
}
